import { api } from "./configs/axiosConfigs";

export const NoticeAPI = {
  getNotices: async () => {
    const response = await api
      .get("/notice")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  getNoticesSearch: async (term) => {
    const response = await api
      .get(`/notice?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },

  createNotice: async (data: any) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("content", data.content);
    formData.append("author", data.author);
    formData.append("date", data.date);
    data.tags.forEach((tag: string, index: number) => {
      formData.append(`tags[${index}]`, tag);
    });
    formData.append("order", String(data.order));
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    formData.append("status", data.status);
    const response = await api.post("/notice", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  editNotice: async (id: number, data: any) => {
    const formData = new FormData();
    formData.append("title", data.title);
    formData.append("content", data.content);
    formData.append("author", data.author);
    formData.append("date", data.date);
    data.tags.forEach((tag: string, index: number) => {
      formData.append(`tags[${index}]`, tag);
    });
    formData.append("order", String(data.order));
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    formData.append("status", data.status);
    const response = await api.post(`/notice/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },

  deleteNotice: async (id: number) => {
    const response = await api
      .delete(`/notice/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return error.response.data;
      });
    return response;
  },
};